import { RobotOutlineIcon } from './RobotOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C0F3E15B-2DFB-4EAF-B41A-2D18EEA22C25
 * name robot-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-outline.svg
 * tags
 */
export const EmojiRobotOutlineIcon = RobotOutlineIcon;
export default EmojiRobotOutlineIcon